export function NoProductivityHack() {
  return (
    <section
      data-testid="no-productivity-hack-section"
      className="relative overflow-hidden"
      style={{ background: "linear-gradient(180deg, #FAFAF8 0%, #F8F7F5 50%, #FAFAF8 100%)" }}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 pt-[44px] md:pt-[66px] pb-[38px] md:pb-[54px]">
        <div className="reveal">
          <div className="border-t border-[#1C1917] mb-8 lg:mb-10" />
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
            <div className="lg:col-span-5 lg:-mt-[8px]">
              <h2 className="font-display text-[38px] sm:text-[48px] lg:text-[62px] leading-[1.05] tracking-tight text-[#1C1917]">
                You Don&rsquo;t Need Another Productivity Hack.
              </h2>
            </div>

            <div className="lg:col-span-7 pt-2 lg:pt-0 lg:-translate-x-[8%]">
              <p className="text-xl lg:text-2xl text-[#57534E] leading-relaxed max-w-[480px] mb-8">
                You probably already know what needs your attention.
              </p>
              <div className="border-l border-[#E8E6E3] pl-6 lg:pl-10 space-y-[24px] mb-[40px]">
                <p className="text-xl lg:text-2xl text-[#57534E] leading-relaxed">That chapter.</p>
                <p className="text-xl lg:text-2xl text-[#57534E] leading-relaxed">That presentation.</p>
                <p className="text-xl lg:text-2xl text-[#57534E] leading-relaxed">Those job applications.</p>
                <p className="text-xl lg:text-2xl text-[#57534E] leading-relaxed">Your business.</p>
                <p className="text-xl lg:text-2xl text-[#57534E] leading-relaxed">The email you&rsquo;ve rewritten seventeen times.</p>
                <p className="text-xl lg:text-2xl text-[#57534E] leading-relaxed">The dream that keeps patiently waiting.</p>
                <p className="text-xl lg:text-2xl text-[#57534E] leading-relaxed">I keep choosing urgent over important.</p>
                <p className="text-xl lg:text-2xl text-[#57534E] leading-relaxed">I know exactly what to do. I just can&rsquo;t seem to begin.</p>
              </div>
              <p className="text-xl lg:text-2xl text-[#57534E] leading-relaxed mb-[40px]">
                What you don&rsquo;t always have is uninterrupted time, gentle accountability and a room full of people quietly choosing progress alongside you.
              </p>
              <p className="font-display text-[36px] text-[#159E9A] leading-snug">
                That&rsquo;s what Spark Sessions are for.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
